import { CHECKER_CLIENT, getCurrentPosition } from "../common";
import * as R from "ramda";

const getZoneName = () => {
  const region = new Intl.DateTimeFormat();
  return region.resolvedOptions().timeZone;
};

const getCurrentCheckPayload = async (email) => {
  const zoneName = getZoneName();
  let currentLocation;
  try {
    currentLocation = await getCurrentPosition();
  } catch (err) {
    throw new Error("We require to use geolocation API");
  }

  const basePayload = {
    zoneName,
    longitude: currentLocation.longitude,
    latitude: currentLocation.latitude,
    accuracy: currentLocation.accuracy,
  };

  const specificPayload = {};
  if (!R.isEmpty(email)) {
    specificPayload.email = email;
  }

  return {
    ...basePayload,
    ...specificPayload,
  };
};

export default {
  namespaced: true,
  state: {
    selectedCheck: undefined,
    checks: [],
  },
  getters: {
    getSelectedCheck: (state) => state.selectedCheck,
    hasSelected: (state) => !!state.selectedCheck,
    getCurrentChecks: (state) => state.checks,
  },
  mutations: {
    SET_SELECTED_CHECK(state, check) {
      state.selectedCheck = check;
    },
    CLEAR_SELECTED_CHECK(state) {
      state.selectedCheck = undefined;
    },
    SET_CHECKS(state, checks) {
      state.checks = checks;
    },
  },
  actions: {
    async fetchChecks({ rootGetters, dispatch, commit }, { to, from, email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const params = !R.isEmpty(to) && !R.isEmpty(from) ? { to, from } : {};
      if (!R.isEmpty(email)) {
        params.email = email;
      }
      const zoneName = getZoneName();
      if (!R.isEmpty(zoneName)) {
        params.zoneName = getZoneName();
      }

      const response = await CHECKER_CLIENT.get("/", {
        headers: { Authorization },
        params,
      });
      const checks = R.sort(R.descend(R.prop("timestamp")), response.data);
      commit("SET_CHECKS", checks);
      return checks;
    },
    async checkIn({ rootGetters, dispatch }, { email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const payload = await getCurrentCheckPayload(email);
      await CHECKER_CLIENT.post("/in", payload, {
        headers: { Authorization },
      });
    },
    async checkOut({ rootGetters, dispatch }, { email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const payload = await getCurrentCheckPayload(email);
      await CHECKER_CLIENT.post("/out", payload, {
        headers: { Authorization },
      });
    },
    async adminCheckIn({ rootGetters, dispatch }, { email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const payload = await getCurrentCheckPayload(email);
      await CHECKER_CLIENT.post("/in", payload, {
        headers: { Authorization },
      });
    },
    async adminCheckOut({ rootGetters, dispatch }, { email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const payload = await getCurrentCheckPayload(email);
      await CHECKER_CLIENT.post("/out", payload, {
        headers: { Authorization },
      });
    },
    async getReportUrl({ rootGetters, dispatch }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const Authorization = `Bearer ${jwtToken}`;

      const result = await CHECKER_CLIENT.get("/report", {
        headers: { Authorization },
      });

      return result.data.downloadUrl;
    },
  },
};
